import React,  { useEffect, useState, useContext } from 'react';
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { useStaticQuery, graphql } from "gatsby";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import { useLocation } from '@reach/router';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

// Components //
import FormModal from "../../ui/modal/Modal";
import Button from "../../atoms/button/button";
import ShareModal from "../../molecules/share-modal/shareModal"

// Contexts //
import GlobalContext from "../../../contexts/globalContext";

// Interfaces //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { ReferenciaEvento } from "../../../interfaces/ReferenciaEvento";

// Utils //
import { splitButtonText } from "../../../utils/helpers";
import { wordFixerForGTM } from "../../../shared/utils/stringUtilities"

// Services //
import { saveForm, getToken, getCmdFormData } from "../../../services/formServices";

// Styles //
import "./eventContent.scss";

export interface CmdUserData {
    companyRole					:	string;
    topics						:	string;
    companyName					:	string;
    expectation_2				:	string;
    mobile						:	string;
    nit							:	string;
    fullName					:	string;
    documentId					:	string;
    expectations				:	string;
    email						:	string;
    dataProcessingAuthorization	:	string;
    eventId                     :   string;
    eventName                   :   string;
}

const EventContent = (props: ReferenciaContenido) => {
    const {
        descripcion,
        fechaEvento,
        horaEvento,
        imagenPrincipal,
        lugarEvento,
        modoEvento,
        tipoEvento,
        tituloBoton,
        redireccionBoton,
        requiereInscripcion
    } = props.referenciaEventos[0];

    const dataEvent = useStaticQuery(graphql`
        query EVENTSCONTENT {
            iconConversatorio: allContentfulAsset(
                filter: { title: { eq: "icon-conversatorio" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconWebinar: allContentfulAsset(
                filter: { title: { eq: "icon-webinar" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconMasterclass: allContentfulAsset(
                filter: { title: { eq: "icon-masterclass" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconFeria: allContentfulAsset(
                filter: { title: { eq: "icon-feria" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconMovil: allContentfulAsset(
                filter: { title: { eq: "icon-movil-empleo" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconContratacion: allContentfulAsset(
                filter: { title: { eq: "icon-contratacion-masiva" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconFeriasInstitucionales: allContentfulAsset(
                filter: { title: { eq: "icon-ferias-institucionales" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            modalAlreadyRegistered: allContentfulContactenos(
                filter: { contentful_id: { eq: "6WroyOy18yvu560deKAJgB" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "5U7pJpWLmh1HUAI9UzMN2K" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            obligatorio
                            seccion
                            tabOrder
                        }
                        tituloBoton
                    }
                }
            }
            formPersonas: allContentfulContactenos(
                filter: { contentful_id: { eq: "1oGm3HJvuVYquCoGPl2zMv" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            obligatorio
                            seccion
                            tabOrder
                        }
                        tituloBoton
                    }
                }
            }    
        }
    `);

    let defaultModalContent:CmdUserData = {
        companyRole					:	"",
        topics						:	"",
        companyName					:	"",
        expectation_2				:	"",
        mobile						:	"",
        nit							:	"",
        fullName					:	"",
        documentId					:	"",
        expectations				:	"",
        email						:	"",
        dataProcessingAuthorization	:	"",
        eventId                     :   "",
        eventName                   :   ""
    };

    const [modalContent, setModalContent] = useState<CmdUserData>(defaultModalContent);
    const [isOpenModalRegistered, setIsOpenModalRegistered] = useState<boolean>(false);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [isOpenPopup, setIsOpenPopup] = useState<boolean>(false);
    const [visibility, setVisibility] = useState<boolean>(false);

    const formFieldsData:any[] = dataEvent.form.nodes[0].titulosFormulario[0].referenciaFormulario;
    const modalAlreadyRegistered = dataEvent.modalAlreadyRegistered.nodes[0];
    const Context = useContext(GlobalContext);
    const { isBrowser, window } = useBrowserMode();

    const popupCloseHandler = (e) => {
        setVisibility(e);
    };
    
    useEffect(() => {
        if (Context.gigyaContext.gigyaAccount !== undefined) {
            const getAccessData = async () => {
                const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
                const responseJson: any = await getCmdFormData(Context!.gigyaContext!.gigyaAccount!.data.docNumber, token);
                const cmdUserData:CmdUserData = responseJson.data.answerData;
                setModalContent({
                    ...modalContent,
                    ...cmdUserData
                });
            }
            getAccessData();
        }
    }, [Context.gigyaContext.gigyaAccount]);

    const handleModal = (eventData:ReferenciaEvento) => {
        if (Context.gigyaContext.gigyaAccount === undefined) {
            Context.gigyaContext.loginComfamaId!();
        } else {
            const eventId = eventData.contentful_id!;
            const eventName = eventData.tituloEvento;
            setModalContent({
                ...modalContent,
                eventId,
                eventName
            });
            setIsOpenModal(true);
        }
    };

    const formModalClose = () => {
        document.body.style.overflow = "initial";
        setIsOpenModal((setShow) => !setShow);
    };

    const formModalRegClose = () => {
        document.body.style.overflow = "initial";
        setIsOpenModalRegistered((setShow) => !setShow);
    };

    const formModalConfirm = async () => {
        document.body.style.overflow = "initial";
        const responseData = await handleSubmitForm();
        setIsOpenModal((setShow) => !setShow);
        if (responseData.data.status === 200) {
            setIsOpenPopup(true);
            setTimeout(() => {
                setIsOpenPopup(false);
            }, 5000);
        }
        else {
            setIsOpenModalRegistered(true);
        }
    };

    const handleSubmitForm = async () => {
        const payload: any = {
            idForm: 4,
            answers: [],
        };
        let formValues = {
            nit         : modalContent.nit,
            companyName : modalContent.companyName,
            fullName    : modalContent.fullName,
            mobile      : modalContent.mobile,
            email       : modalContent.email,
            eventName   : modalContent.eventName,
            eventId     : modalContent.eventId,
            documentId  : modalContent.documentId
        };
        Object.entries(formValues).forEach(([key, value]) => {
            payload.answers.push({ contentfulId: key, answer: value });
        });
        const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
        const response = await saveForm(payload, token);
        return response;
    };

    const Popup = ({ children }) => {
        return (
            <div className={`alert alert-info`}>
                {children}
            </div>
        )
    }   

    const iconsObj: {[key: string]: string} = {
        "Conversatorio": dataEvent.iconConversatorio.nodes[0].file.url,
        "Feria de empleo": dataEvent.iconFeria.nodes[0].file.url,
        "Webinar": dataEvent.iconWebinar.nodes[0].file.url,
        "Mentoría": dataEvent.iconConversatorio.nodes[0].file.url,
        "Masterclass": dataEvent.iconMasterclass.nodes[0].file.url,
        "Contratación masiva": dataEvent.iconContratacion.nodes[0].file.url,
        "Móvil de empleo": dataEvent.iconMovil.nodes[0].file.url,
        "Ferias institucionales": dataEvent.iconFeriasInstitucionales.nodes[0].file.url
    }

    const RenderOptions = {
        renderNode: {
            [INLINES.HYPERLINK]: ({ data }, children) => (
                <a
                    style={{ color: "var(--color-magenta-white)" }}
                    href={data.uri}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                >
                    {children}
                </a>
            ),
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p className="paragraph">{children}</p>;
            },
            [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
                return (
                    <p>
                        <img
                            src={`https://${node.data.target.fields.file["en-US"].url}`}
                            height={260}
                            width={250}
                            alt={node.data.target.fields.description}
                        />
                    </p>
                );
            },
        },
        renderText: (text) =>
            text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
    };

    const validUrl = (pathname: string) => {
        if(isBrowser) {
            return `${window.location.origin}/servicio-de-empleo${pathname}`
        }
    }

    //Bloque creado para google tag manager//
    const accentReplacements = {
        '%C3%A1': 'a',
        '%C3%A9': 'e',
        '%C3%AD': 'i',
        '%C3%B3': 'o',
        '%C3%BA': 'u',
    };
    const decodeUtf8Accents = (str) => {
        for (const [encoded, replacement] of Object.entries(accentReplacements)) {
        const regex = new RegExp(encoded, 'g');
        str = str.replace(regex, replacement);
        }
        return decodeURIComponent(str);
    };
    const location = useLocation();
    const pathName = location.pathname.split('/').reverse()[1];
    const pathNameFixed = wordFixerForGTM(decodeUtf8Accents(pathName).replace(/-/g, '_'));
    const isComunidades = location.pathname.includes('/comunidades/');
    //Bloque creado para google tag manager//
    
    return (
        <>
            {/* MODAL YA INSCRITO */}
            {isOpenModalRegistered && (
                <FormModal showModal={isOpenModalRegistered} onClose={formModalRegClose}>
                    <div className="m-modal-content">
                        <div className="m-modal-content__form">
                            <div className="m-modal-content__form__item registered">
                                <div className="m-modal-content__form__item__label">
                                    <img src={modalAlreadyRegistered.imagenFormulario.file.url}/>
                                </div>
                                <div className="m-modal-content__form__item__msg">
                                    {modalAlreadyRegistered.tituloPrincipal}
                                </div>
                            </div>
                        </div>
                        <div className="m-modal-content__form__buttonbar">
                            <div className="m-modal-content__form__buttonbar__msgbutton">
                                <Button
                                    type="button"
                                    text="ACEPTAR"
                                    classname={`a-button__magenta m-modal__button`}
                                    isDisabled={false}
                                    onClickAction={formModalRegClose}
                                />
                            </div>
                        </div>
                    </div>
                </FormModal>
            )}

            {/* MODAL INSCRIPCION */}
            {isOpenModal && (
                <FormModal showModal={isOpenModal} onClose={formModalClose}>
                    <div className="m-modal-content">
                        <h2 className="m-modal-content__title">
                            Confirma tu inscripción a este evento
                        </h2>
                        <div className="m-modal-content__form">
                            {formFieldsData.map((field, index) => {
                                return (
                                    <div className={`m-modal-content__form__item ${field.inputPrincipal}`} key={index}>
                                        <div className="m-modal-content__form__item__label">
                                            {field.inputPrincipal}
                                        </div>
                                        <div className="m-modal-content__form__item__value">
                                            {modalContent[field.nombreId]}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="m-modal-content__form__buttonbar">
                            <div className="m-modal-content__form__buttonbar__button">
                                <Button
                                    type="button"
                                    text="CANCELAR"
                                    classname={`a-button__magenta m-modal__button cancel`}
                                    isDisabled={false}
                                    onClickAction={formModalClose}
                                />
                            </div>
                            <div className="m-modal-content__form__buttonbar__button">
                                <Button
                                type="button"
                                text="CONFIRMAR"
                                classname={`a-button__magenta m-modal__button confirm`}
                                isDisabled={false}
                                onClickAction={formModalConfirm}
                                />
                            </div>
                        </div>
                    </div>
                </FormModal>
            )}

            {isOpenPopup && (
                <Popup>
                    Registro confirmado
                </Popup>
            )}

            <div className="o-event-content">
                <div className="container">
                    <div className="o-event-content__container">
                        <div className="o-event-content__container__left">
                            <div className="event-description">
                                <div className="event-description__top">
                                    <div className="type">
                                        <img src={iconsObj[tipoEvento]} alt={tipoEvento} />
                                        <span>{tipoEvento}</span>
                                    </div>
                                    <span className="share" onClick={() => setVisibility(true)}>
                                        <i className="icon-share-alt"></i>
                                        Compartir
                                    </span>
                                </div>
                                <div className="event-description__image">
                                    <img src={imagenPrincipal.file.url} alt="" />
                                </div>
                                <div className="event-description__text">
                                {descripcion &&
                                    documentToReactComponents(descripcion.json, RenderOptions)}
                                </div>
                            </div>
                        </div>
                        <div className="o-event-content__container__right">
                            <div className="event-detail">
                                <div className="event-detail__item">
                                    <span>
                                        <svg id="calendario_17_" data-name="calendario (17)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path id="Trazado_77114" data-name="Trazado 77114" d="M19,2H18V1a1,1,0,1,0-2,0V2H8V1A1,1,0,1,0,6,1V2H5A5.006,5.006,0,0,0,0,7V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V7A5.006,5.006,0,0,0,19,2ZM2,7A3,3,0,0,1,5,4H19a3,3,0,0,1,3,3V8H2ZM19,22H5a3,3,0,0,1-3-3V10H22v9A3,3,0,0,1,19,22Z" fill="#474747"/>
                                            <circle id="Elipse_1952" data-name="Elipse 1952" cx="1.5" cy="1.5" r="1.5" transform="translate(10.5 13.5)"/>
                                            <circle id="Elipse_1953" data-name="Elipse 1953" cx="1.5" cy="1.5" r="1.5" transform="translate(5.5 13.5)"/>
                                            <circle id="Elipse_1954" data-name="Elipse 1954" cx="1.5" cy="1.5" r="1.5" transform="translate(15.5 13.5)"/>
                                        </svg>
                                    </span>
                                    <p>
                                        <strong>Fecha</strong>
                                        {`${splitButtonText(fechaEvento,2,",")}, ${splitButtonText(fechaEvento,0,",")} de ${splitButtonText(fechaEvento,1,",")}`}
                                    </p>
                                </div>
                                <div className="event-detail__item">
                                    <span>
                                        {modoEvento === "Presencial" ? (
                                            <svg id="Componente_611_1" data-name="Componente 611 – 1" xmlns="http://www.w3.org/2000/svg" width="24.773" height="24.773" viewBox="0 0 24.773 24.773">
                                                <rect id="Rectángulo_84750" data-name="Rectángulo 84750" width="24.773" height="24.773" fill="none"/>
                                                <g id="usuario" transform="translate(3.955 3.829)">
                                                <path id="Trazado_76058" data-name="Trazado 76058" d="M11.529,11.058A5.529,5.529,0,1,0,6,5.529,5.529,5.529,0,0,0,11.529,11.058Zm0-9.215A3.686,3.686,0,1,1,7.843,5.529,3.686,3.686,0,0,1,11.529,1.843Z" transform="translate(-3.235 0)" fill="#474747"/>
                                                <path id="Trazado_76059" data-name="Trazado 76059" d="M11.294,14A8.3,8.3,0,0,0,3,22.294a.922.922,0,1,0,1.843,0,6.451,6.451,0,1,1,12.9,0,.922.922,0,1,0,1.843,0A8.3,8.3,0,0,0,11.294,14Z" transform="translate(-3 -1.099)" fill="#474747"/>
                                                </g>
                                            </svg>
                                        ):(
                                            <svg id="Componente_611_1" data-name="Componente 611 – 1" xmlns="http://www.w3.org/2000/svg" width="33.273" height="33.362" viewBox="0 0 33.273 33.362">
                                                <rect id="Rectángulo_84750" data-name="Rectángulo 84750" width="24.773" height="24.773" transform="translate(3.5 3.588)" fill="none"/>
                                                <g id="Grupo_16726" data-name="Grupo 16726" transform="translate(-710 -697)">
                                                    <rect id="Rectángulo_84751" data-name="Rectángulo 84751" width="32.089" height="32.089" transform="translate(710 697)" fill="none"/>
                                                    <path id="ordenador-portatil_1_" data-name="ordenador-portatil (1)" d="M20.438,14.319V7.645A4.65,4.65,0,0,0,15.793,3H6.5A4.65,4.65,0,0,0,1.858,7.645v6.674a2.78,2.78,0,0,0,.929,5.4H19.509a2.78,2.78,0,0,0,.929-5.4ZM6.5,4.858h9.29A2.787,2.787,0,0,1,18.58,7.645v6.5H14.724a1.858,1.858,0,0,0-1.419.658l-.229.271H9.22l-.229-.271a1.858,1.858,0,0,0-1.419-.658H3.716v-6.5A2.787,2.787,0,0,1,6.5,4.858ZM19.509,17.864H2.787a.929.929,0,0,1,0-1.858H7.573l.229.271a1.858,1.858,0,0,0,1.419.658h3.854a1.858,1.858,0,0,0,1.419-.658l.229-.271h4.785a.929.929,0,1,1,0,1.858Z" transform="translate(715.856 702.404)" fill="#474747"/>
                                                </g>
                                            </svg>
                                        )}
                                    </span>
                                    <p>
                                        <strong>Modalidad</strong>
                                        {modoEvento}
                                    </p>
                                </div>
                                <div className="event-detail__item">
                                    <span>
                                        <svg id="sitio" xmlns="http://www.w3.org/2000/svg" width="18.025" height="22.28" viewBox="0 0 18.025 22.28">
                                            <g id="Grupo_15515" data-name="Grupo 15515">
                                                <g id="Grupo_15514" data-name="Grupo 15514">
                                                    <path id="Trazado_76055" data-name="Trazado 76055" d="M65.294,3.874a9,9,0,0,0-14.79,0,9,9,0,0,0-1.047,8.289,7.085,7.085,0,0,0,1.306,2.156l6.544,7.686a.778.778,0,0,0,1.186,0l6.542-7.684a7.093,7.093,0,0,0,1.306-2.153A9,9,0,0,0,65.294,3.874Zm-.413,7.749a5.557,5.557,0,0,1-1.028,1.683l0,0L57.9,20.3l-5.954-6.994a5.56,5.56,0,0,1-1.029-1.688,7.442,7.442,0,0,1,.87-6.858,7.438,7.438,0,0,1,12.227,0A7.444,7.444,0,0,1,64.881,11.623Z" transform="translate(-48.886)" fill="#303030"/>
                                                </g>
                                            </g>
                                            <g id="Grupo_15517" data-name="Grupo 15517" transform="translate(4.28 4.37)">
                                                <g id="Grupo_15516" data-name="Grupo 15516">
                                                    <path id="Trazado_76056" data-name="Trazado 76056" d="M160.486,106.219a4.732,4.732,0,1,0,4.732,4.732A4.738,4.738,0,0,0,160.486,106.219Zm0,7.775a3.042,3.042,0,1,1,3.042-3.042A3.046,3.046,0,0,1,160.486,113.994Z" transform="translate(-155.754 -106.219)" fill="#303030"/>
                                                </g>
                                            </g>
                                        </svg>
                                    </span>
                                    <p>
                                        <strong>Lugar</strong>
                                        {lugarEvento}
                                    </p>
                                </div>
                                <div className="event-detail__item">
                                    <span>
                                        <svg id="reloj" xmlns="http://www.w3.org/2000/svg"width="21" height="21" viewBox="0 0 21 21">
                                            <path id="Trazado_76052" data-name="Trazado 76052" d="M10.5,0A10.5,10.5,0,1,0,21,10.5,10.5,10.5,0,0,0,10.5,0Zm0,19.25a8.75,8.75,0,1,1,8.75-8.75A8.75,8.75,0,0,1,10.5,19.25Z" transform="translate(0 0)" fill="#303030"/>
                                            <path id="Trazado_76053" data-name="Trazado 76053" d="M12,6a1,1,0,0,0-1,1v4.325L7.629,13.437a1,1,0,0,0,1.062,1.7l3.84-2.4A1,1,0,0,0,13,11.879V7A1,1,0,0,0,12,6Z" transform="translate(-1.183 -1.224)" fill="#303030"/>
                                        </svg>
                                    </span>
                                    <p>
                                        <strong>Hora</strong>
                                        {horaEvento}
                                    </p>
                                </div>
                                {requiereInscripcion ? (
                                    <button 
                                        className = {
                                            `event-detail__button ${isComunidades ? "gtm_inscribete_aqui_eventos_comunidades_"+pathNameFixed : ""}`
                                        } 
                                        data-topic-title={pathNameFixed} 
                                        onClick={() => 
                                            handleModal(props.referenciaEventos[0])
                                        }
                                    >
                                        {tituloBoton}
                                    </button>
                                ) : (
                                    <a 
                                        href={redireccionBoton ?? "#"}
                                        target="_blank" 
                                        className={
                                            `event-detail__button ${isComunidades ? "gtm_conectate_aqui_eventos_comunidades_"+pathNameFixed : ""}`
                                        }
                                        data-topic-title={pathNameFixed}
                                    >
                                        {tituloBoton}
                                    </a>
                                )}
                            </div>
                            <div className="description-mobile">
                                {descripcion &&
                                    documentToReactComponents(descripcion.json, RenderOptions)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ShareModal isOpen={visibility} onClose={popupCloseHandler} link={validUrl(props.location?.pathname)}/>
        </>
    )
}

export default EventContent;